const importProductsDictPT = {
  importProductsFromCSVFile: "Carregue um arquivo .csv abaixo para importar produtos dele",
  importTemplateExplanation:
    "APENAS dados básicos como título, descrição, preço e imagens serão importados, você ainda precisará revisar cada produto resultante e editá-los de acordo. As variantes do produto também não são importadas e devem ser configuradas de acordo.",
  fringeBenefitDownloadedSuccessfully: "Flexible Benefit baixado com sucesso",
  discharge: "Dar baixa",
  doYouWantToCancelTheProductBelow: "Deseja dar baixa no voucher abaixo?",
  wasDischargedFromFringeBenefit: "Foi dado baixa no Flexible Benefit",
  associatedVoucher: "Voucher(s) Associados",
};

export default importProductsDictPT;
